<template>
  <div class="flex flex-wrap w-full relative" id="listings-container">
    <brokerage-sortbar
        :view="view"
        :matches="matches"
        :loading="loading"
        :sort-option="sortOption"
        :has-active-filters="hasActiveFilters"
        @update:view="$emit('update:view', $event)"
        @update:sort-option="$emit('update:sort-option', $event)"
        @reset-filters="$emit('reset-filters')"
    />
    <!-- List View or Split View -->
    <ul
        class="listings listings--map flex flex-wrap items-start -mx-5"
        :class="[view === 'list' ? 'w-full' : 'w-1/2 overflow-scroll -mt-10 fade']"
        v-show="view !== 'map'"
    >
      <li
          v-for="(listing, index) in listings"
          :key="listing.id + '-' + index"
          class="w-full sm:w-1/2 lg:w-1/3 2xl:w-1/4 px-5 pb-10"
      >
        <brokerage-card :listing="listing" />
      </li>
    </ul>
    <!-- Map View -->
    <brokerage-map
        v-if="view === 'map'"
        :listings="listings"
        :boundingBox="mapBounding"
        :loading="loading"
        @update-map="handleMapUpdate"
    />
  </div>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import BrokerageCard from './brokerage-card.vue';
import BrokerageSortbar from './brokerage-sortbar.vue';

const BrokerageMap = defineAsyncComponent(() => import('./brokerage-map.vue'));

export default {
  components: {
    BrokerageCard,
    BrokerageMap,
    BrokerageSortbar,
  },
  props: {
    listings: { type: Array, default: () => [] },
    view: {
      type: String,
      default: 'list',
    },
    loading: { type: Boolean, default: false },
    mapBounding: { type: Object, default: null },
    matches: {
      type: Number,
      default: 0,
    },
    sortOption: {
      type: String,
      default: 'relevance',
    },
    hasActiveFilters: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:view', 'update:sort-option', 'update-map', 'reset-filters'],
  methods: {
    handleMapUpdate(bounds) {
      this.$emit('update-map', bounds);
    },
  },
};
</script>

<style scoped>
.map-container {
  position: relative;
}
</style>
